"use client";

import Loading from "@/components/Loading";
import CuMeoThreeColSection from "./CuMeoThreeColSection";
import CuMeoCorrectScoresSection from "./CuMeoCorrectScoresSection";
import "./index.css";

export default function CuMeoOtherBetsDropdown({
  loadingOtherOdds,
  otherOddsData,
  hasOtherData,
  correctScoresListFull = [],
  correctScoresFull = { home: [], draw: [], away: [] },
  totalCornersOdds = [],
  odds = {},
  showOther,
}) {
  return (
    <div className={`cumeo-odt-wrapper min-w-0 overflow-hidden ${showOther ? "active" : ""}`}>
      {loadingOtherOdds && !otherOddsData && (
        <div className="w-full py-4">
          <Loading />
        </div>
      )}
      {!loadingOtherOdds && otherOddsData && !hasOtherData && (
        <div className="cumeo-odt-empty">Chưa có dữ liệu kèo cược khác</div>
      )}
      {!loadingOtherOdds && hasOtherData && (
        <div className="cumeo-odds-detail-table">
          <div className="flex flex-wrap gap-1 md:gap-y-[10px] md:gap-x-4">
            <CuMeoThreeColSection
              title="Kèo phạt góc"
              items={[
                { label: "Đội nhà", value: totalCornersOdds?.[0]?.over, trend: totalCornersOdds?.[0]?.initialOverTrend },
                { label: "Đội khách", value: totalCornersOdds?.[0]?.under, trend: totalCornersOdds?.[0]?.initialUnderTrend },
                { label: "Hòa", value: null },
              ]}
              width="ods-100"
            />

            {/* FT 1x2 + HT 1x2 */}
            <CuMeoThreeColSection
              title="FT 1x2"
              items={[
                { label: "Đội nhà", value: odds?.homeEuropeOdds, trend: odds?.homeEuropeTrend },
                { label: "Đội khách", value: odds?.awayEuropeOdds, trend: odds?.awayEuropeTrend },
                { label: "Hòa", value: odds?.instantDrawOdds, trend: odds?.drawTrend },
              ]}
              width="ods-50"
            />

            <CuMeoThreeColSection
              title="HT 1x2"
              items={[
                { label: "Đội nhà", value: odds?.homeHandicapHalfOdds, trend: odds?.homeHandicapHalfTrend },
                { label: "Đội khách", value: odds?.awayHandicapHalfOdds, trend: odds?.awayHandicapHalfTrend },
                { label: "Hòa", value: null },
              ]}
              width="ods-50"
            />

            {correctScoresListFull.length > 0 && (
              <CuMeoCorrectScoresSection
                title="Tỷ số chính xác toàn trận"
                correctScoresFull={correctScoresFull}
              />
            )}

          </div>
        </div>
      )}
    </div>
  );
}
